/**
 * Typed access to build-time environment variables.
 *
 * Almost nothing is configured at build time on purpose: ONE build serves every
 * tenant, and the tenant's name, colors, logo and modules come from the API at
 * runtime (see src/tenant). Only infrastructure concerns live here.
 */

export const AUTH_PROVIDERS = ['backend', 'mock'] as const;
export type AuthProviderId = (typeof AUTH_PROVIDERS)[number];

export interface AppEnv {
  /** Base URL of the API. Same-origin by default, so cookies stay host-only. */
  apiUrl: string;
  /** `backend` in real use; `mock` only for UI prototyping and tests. */
  authProvider: AuthProviderId;
  /** Shown while the tenant configuration loads and on platform screens. */
  platformName: string;
}

const raw = import.meta.env;

function read(name: string): string {
  const value = raw[name];
  return typeof value === 'string' ? value.trim() : '';
}

function parseProvider(value: string): AuthProviderId {
  const normalized = value.toLowerCase();
  return (AUTH_PROVIDERS as readonly string[]).includes(normalized)
    ? (normalized as AuthProviderId)
    : 'backend';
}

export const env: AppEnv = {
  apiUrl: read('VITE_API_URL').replace(/\/+$/, '') || '/api/v1',
  authProvider: parseProvider(read('VITE_AUTH_PROVIDER')),
  platformName: read('VITE_PLATFORM_NAME') || 'Plataforma Saúde',
};
